import React from 'react';
import { Button, Text } from '@spothero/ui';
import useTouch from 'hooks/use-touch';
const DynamicSpotListItemButton = ({ isAdmin, available, isRebookingReservation, isHovered, onClick, isMonthly = false, isAirport = false, ...props }) => {
    const isUnavailable = isAdmin && !available;
    const dynamicCTA = isUnavailable
        ? 'Unavailable'
        : isRebookingReservation
            ? 'Rebook It'
            : isMonthly
                ? 'View Details'
                : 'Book Now';
    // The hover state is applied when:
    // 1. The button is hovered
    // 2. The corresponding spot pin on the map is hovered
    const oklchMatch = `oklch(from var(--chakra-colors-primary-default) calc(l - 0.1) c h)`;
    const dynamicButtonStyleProps = {
        marginLeft: 4,
        backgroundColor: isHovered ? oklchMatch : 'primary.default',
        borderColor: isHovered ? oklchMatch : 'primary.default',
        _hover: {
            backgroundColor: isUnavailable ? 'gray.medium' : oklchMatch,
            borderColor: isUnavailable ? 'gray.medium' : oklchMatch,
            color: isUnavailable ? 'gray.dark' : 'white',
        },
    };
    const monthlyDynamicButtonStyleProps = {
        color: isHovered && !isUnavailable
            ? 'primary.600'
            : isUnavailable
                ? 'gray.dark'
                : 'primary.default',
        _hover: {
            color: !isUnavailable ? 'primary.600' : 'gray.dark',
        },
    };
    const adminBorderButtonStyleProps = {
        borderColor: 'warning',
        borderWidth: '4px',
        borderStyle: 'solid',
        borderRadius: '4px',
        ...(isMonthly && { padding: 1 }),
        _hover: {
            borderColor: 'warning',
            ...(!isMonthly && { backgroundColor: 'primary.600' }),
        },
    };
    const handleClick = (e) => {
        // We stop propagation here to prevent the parent element from being clicked.
        e.stopPropagation();
        if (onClick) {
            onClick(e);
        }
    };
    const { onTouchStart, onTouchEnd } = useTouch(handleClick);
    return (<Button data-testid={isAirport
            ? 'SpotDetails-reservation-summary-book-now'
            : 'SpotCardDynamicCTAButton'} variant={isMonthly && !isUnavailable ? 'tertiary' : 'primary'} onClick={handleClick} onTouchStart={onTouchStart} onTouchEnd={onTouchEnd} isDisabled={isUnavailable} {...(isMonthly
        ? { ...monthlyDynamicButtonStyleProps }
        : { ...dynamicButtonStyleProps })} {...(isAdmin &&
        isRebookingReservation && { ...adminBorderButtonStyleProps })} {...props}>
            {dynamicCTA}
            {isUnavailable && (<Text as="sup" variant="caption" lineHeight={0}>
                    *
                </Text>)}
        </Button>);
};
export default DynamicSpotListItemButton;
